import { atom } from "recoil";

export const viewerState = atom({
    key: "viewerState",
    default: {
        input: {},
        itype: {},
    },
});
